// extracted by mini-css-extract-plugin
export default {"animation":"Loader_animation__q0c37"};